import { Box, Flex, Input, Text } from '@chakra-ui/react';

// EG-27 (rework): janela de validade por MÊS/ANO (início → fim) usada nas
// caixinhas de selo (Selo 1 / Selo 2). Valores em "YYYY-MM" (<input type=month>).
export default function MonthRangeFields({ label, from, until, onFrom, onUntil }) {
  return (
    <Box mt='16px'>
      {label && (
        <Text fontSize='sm' fontWeight={600} color='#5C6066' mb='8px'>
          {label}
        </Text>
      )}
      <Flex align='flex-end' gap='4' flexWrap='wrap'>
        <Box>
          <Text fontSize='xs' color='#818A8F' mb='4px'>
            Início
          </Text>
          <Input
            type='month'
            w='180px'
            h='48px'
            borderRadius='8px'
            border='1px solid #B8CAE8'
            value={from || ''}
            onChange={(e) => onFrom(e.target.value)}
          />
        </Box>
        <Box>
          <Text fontSize='xs' color='#818A8F' mb='4px'>
            Fim
          </Text>
          <Input
            type='month'
            w='180px'
            h='48px'
            borderRadius='8px'
            border='1px solid #B8CAE8'
            value={until || ''}
            onChange={(e) => onUntil(e.target.value)}
          />
        </Box>
      </Flex>
    </Box>
  );
}
